function getPosition(item, positionCache) {
    if (positionCache.has(item)) {
        return positionCache.get(item);
    }

    var position = { top: 0, left: 0 };

    try {
        var annotationObject = item?.annotations?.[0]?.annotationObject;
        var parsed = annotationObject ? JSON.parse(annotationObject) : {};
        position = {
            top: typeof parsed.top === 'number' ? parsed.top : 0,
            left: typeof parsed.left === 'number' ? parsed.left : 0
        };
    } catch (e) {
        position = { top: 0, left: 0 };
    }

    positionCache.set(item, position);
    return position;
}

function sortGroupByPosition(items, positionCache) {
    items.sort(function (a, b) {
        var posA = getPosition(a, positionCache);
        var posB = getPosition(b, positionCache);

        if (posA.top !== posB.top) {
            return posA.top - posB.top;
        }

        return posA.left - posB.left;
    });

    return items;
}

function groupByPage(items, pageCount) {
    var groups = {};
    var groupKeys = [];

    for (var i = 1; i <= pageCount; i++) {
        groups[i] = [];
        groupKeys.push(i);
    }

    for (var j = 0; j < items.length; j++) {
        var page = items[j].page || 1;
        if (!groups[page]) {
            groups[page] = [];
            groupKeys.push(page);
        }
        groups[page].push(items[j]);
    }

    return { groups: groups, groupKeys: groupKeys };
}

function groupByFrame(items) {
    var groups = {};
    var groupKeys = [];

    for (var i = 0; i < items.length; i++) {
        var frame = items[i].frameRange ? items[i].frameRange[0] : 0;
        if (!groups[frame]) {
            groups[frame] = [];
            groupKeys.push(frame);
        }
        groups[frame].push(items[i]);
    }

    groupKeys.sort(function (a, b) {
        return a - b;
    });

    return { groups: groups, groupKeys: groupKeys };
}

function sortPositionally(items, options = {}) {
    var pageCount = options.pageCount;
    var isVideo = options.isVideo;
    var positionCache = new Map();

    if (!isVideo && (!pageCount || pageCount <= 1)) {
        return sortGroupByPosition(items, positionCache);
    }

    var grouped = isVideo ? groupByFrame(items) : groupByPage(items, pageCount);
    var groups = grouped.groups;
    var groupKeys = grouped.groupKeys;
    var sortedItems = [];

    for (var i = 0; i < groupKeys.length; i++) {
        var group = groups[groupKeys[i]];
        if (group.length === 0) {
            continue;
        }

        sortGroupByPosition(group, positionCache);
        for (var j = 0; j < group.length; j++) {
            sortedItems.push(group[j]);
        }
    }

    return sortedItems;
}

export const commentPositionalSort = {
    sortPositionally
};
